export default __webpack_public_path__ + "static/media/AC_1.dc91ab4a.jpg";